import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Brand from '@src/mobile/components/Brand';
import styles from './index.css';
import { Store } from './store';
import Wrap from './Wrap';
import Banner from './Banner';
import List from './List';

const Layout = ({ content }) => {
    return (
        <div className={styles.layout}>
            <Store.Provider>
                <Wrap content={content.h5}>
                    <Banner />
                    <List />
                    <Brand />
                </Wrap>
            </Store.Provider>
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
